import { render } from "./Emails.vue?vue&type=template&id=bb0572e4"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"
script.render = render

export default script